export type PasswordRules = {
  minLength?: number;
  requireNumber?: boolean;
};

export const defaultPasswordRules: Required<PasswordRules> = {
  minLength: 8,
  requireNumber: false,
};

export const strictPasswordRules: Required<PasswordRules> = {
  minLength: 8,
  requireNumber: true,
};
